<template>
  <div>
    <h3>Active Rules: {{ pagination.totalItems }}</h3>

    <p>An email in this exceptions list, will bypass any registration restriction rules and be able to create a new company account.</p>
    <sup>(accounts that are added to an existing company account don't need this)</sup>

    <GridContainer
      form-container
      class="align-left"
    >
      <el-form @submit.native.prevent>
        <el-form-item>
          <div class="flex">
            <el-input
              v-model="newRuleEmail"
              class="flex-1"
              type="text"
              placeholder="Type email to include in the list"
              name="newRuleEmail"
              clearable
              @blur="$v.newRuleEmail.$touch()"
              @keyup.enter.native="submitOnEnter"
            />
            <el-button
              type="primary"
              :disabled="$v.newRuleEmail.$invalid"
              @click="addNewEmail"
            >
              Add Rule
            </el-button>
          </div>
        </el-form-item>
      </el-form>
    </GridContainer>

    <el-table
      v-loading="loading"
      class="cursor-pointer"
      border
      :data="exceptionsList"
      highlight-current-row
    >
      <el-table-column
        prop="name"
        label="Email"
      />
      <el-table-column
        prop="registered"
        label="Registered"
        align="center"
      >
        <template slot-scope="scope">
          <registered-icon :is-registered="scope.row.registered" />
        </template>
      </el-table-column>
      <el-table-column
        prop="activated"
        label="Activated"
        align="center"
      >
        <template slot-scope="scope">
          <activated-icon :is-activated="scope.row.activated" />
        </template>
      </el-table-column>
      <el-table-column
        label="Actions"
        align="center"
      >
        <template slot-scope="scope">
          <el-button
            type="primary"
            @click="deleteExceptionConfirmation(scope.row)"
          >
            Delete Rule
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      class="has-top-padding is-centered"
      background
      layout="prev, pager, next"
      :page-size="pagination.pageSize"
      :total="pagination.totalItems"
      @current-change="changePaginationPage"
    />
  </div>
</template>

<script>
import axios from '@/axios/axios'

import { validationMixin } from 'vuelidate'
import { required, email } from 'vuelidate/lib/validators'

import ActivatedIcon from '@/components/ActivatedIcon/ActivatedIcon'
import RegisteredIcon from '@/components/RegisteredIcon/RegisteredIcon'

export default {
  name: 'RegistrationExceptions',
  components: {
    RegisteredIcon,
    ActivatedIcon
  },
  mixins: [ validationMixin ],
  data() {
    return {
      pagination: {
        currentPage: 1,
        pageSize: 12,
        totalItems: 0
      },
      newRuleEmail: '',
      exceptionsList: [],
      loading: null
    }
  },
  validations: {
    newRuleEmail: {
      required,
      email
    }
  },
  created() {
    this.getRegisterExceptions()
  },
  methods: {
    changePaginationPage(page) {
      this.pagination.currentPage = page
      this.getRegisterExceptions()
    },

    getRegisterExceptions() {
      this.loading = true

      const params = {
        page: this.pagination.currentPage - 1,
        size: this.pagination.pageSize
      }

      return axios.get('admin/registration-exceptions', {
        params
      })
        .then(res => {
          this.exceptionsList = res.data.content
          this.pagination.totalItems = res.data.totalElements
          this.pagination.currentPage = params.page

          this.loading = false
        })
    },

    submitOnEnter() {
      if (!this.$v.newRuleEmail.$invalid) {
        this.addNewEmail()
      }
    },

    addNewEmail() {
      const data = {
        name: this.newRuleEmail
      }

      return axios.post('admin/registration-exception/create', data)
        .then(res => {
          if (res.status === 200) {
            this.$notify({
              title: 'Success',
              message: 'Email exception has been added to the list.',
              type: 'success'
            })
          }

          this.getRegisterExceptions()
        })
        .catch(axios.errorNotify)
    },

    deleteExceptionConfirmation(rule) {
      if (!rule.registered) {
        this.$confirm('Removing this rule will disable the ability for the user to register. Are you sure you want to continue?')
          .then(_ => {
            this.deleteException(rule)
          })
          .catch(_ => {})
      }
      else {
        this.deleteException(rule)
      }
    },

    deleteException(rule) {
      return axios.delete(`admin/registration-exception/delete/${rule.id}`)
        .then(res => {
          if (res.status === 200) {
            this.$notify({
              title: 'Success',
              message: 'Email exception has been deleted.',
              type: 'success'
            })
          }

          this.getRegisterExceptions()
        })
        .catch(axios.errorNotify)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "~vars";

  .align-left {
    margin-left: 0;
  }

  .el-icon-success {
    color: $-color-success;
  }

  .el-icon-error {
    color: $-color-error;
  }
</style>
